import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { I18nProperties, DefaultChildrenWNodeFactory } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import css from '../css/resource-parser.m.css';

export interface ResourceImgProperties {
	src: string;
	alt: string;
	height?: string;
	width?: string;
}

const factory = create({ theme }).properties<ResourceImgProperties>();

export const ResourceImg = factory(({ properties, children, middleware: { theme } }) => {
	const { src = '', alt = '', height = '', width = '' } = properties();
	const themeCss = theme.classes(css);

	return v('img', { classes: [themeCss.image], height, width, src, alt }, children());
});
